import React from 'react';
import { Loader } from '@weezevent/nacre';
export default function Loading() {
    return (
        <div
            style={{
                height: '100vh',
                width: '100vw',
                position: 'fixed',
                top: 0,
                // This is pretty hacky, but only meant to better align the spinner horizontally, nothing
                // critical. We move the spinner a bit to the right if it's shown in the content area of
                // the template
                left: document.querySelector('.wz-leftmenu') && window.innerWidth > 960 ? 260 / 2 : 0,
                pointerEvents: 'none'
            }}
        >
            <Loader />
        </div>
    );
}
